import { useState } from 'react';
import { Badge, Button, Flex, List, Popover, Space, Typography } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNotification } from '@/context/NotificationContext';
import dayjs from 'dayjs';
import { useMutation } from '@tanstack/react-query';
import { fcmApi } from '@/services/fcm/fcm.service.ts';

export const NotificationMenu = () => {
  const { notifications } = useNotification();

  const [open, setOpen] = useState(false);

  const { mutate: markNotificationAsRead } = useMutation({
    mutationFn: fcmApi.markedNotificationAsRead,
  });

  const unreadCount = notifications?.filter((notify) => !notify.marked_as_read_at)?.length || 0;

  const handleNotificationClick = (id: string) => {
    markNotificationAsRead({
      notificationId: id,
    });
  };

  const notificationList = (
    <div style={{ width: 320, maxHeight: 400, overflowY: 'auto' }}>
      <List
        dataSource={notifications || []}
        locale={{ emptyText: 'No notifications' }}
        renderItem={(item) => (
          <List.Item
            style={{
              backgroundColor: item.marked_as_read_at ? '#f9f9f9' : '#e6f4ff',
              borderRadius: 8,
              marginBottom: 4,
              padding: 12,
              marginRight: 8,
            }}
          >
            <List.Item.Meta
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography.Text strong>{item.location?.room_name || item.title}</Typography.Text>
                  <Typography.Text type='secondary' style={{ fontSize: 11 }}>
                    {item.sent_at ? dayjs(item.sent_at.toDate()).format('MM/DD HH:mm') : ''}
                  </Typography.Text>
                </div>
              }
              description={
                <Flex vertical>
                  <Typography.Text strong>Message:</Typography.Text>
                  <Typography.Text style={{ whiteSpace: 'pre-line' }}>{item.body}</Typography.Text>
                  {!item.marked_as_read_at && (
                    <Flex vertical style={{ marginTop: 4 }}>
                      <span onClick={() => handleNotificationClick(item.id)}>
                        <a>Mark as read</a>
                      </span>
                    </Flex>
                  )}
                </Flex>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );

  return (
    <>
      <Space size='middle' style={{ justifyContent: 'end' }}>
        <Popover
          content={notificationList}
          trigger='click'
          placement='bottomRight'
          open={open}
          onOpenChange={setOpen}
        >
          <Badge count={unreadCount} size='small' offset={[-6, 6]}>
            <Button
              type='text'
              icon={<BellOutlined />}
              className='notification-bell'
              aria-label='Notifications'
            />
          </Badge>
        </Popover>
      </Space>
    </>
  );
};
